export const SIGN_IN_CALLBACK_RETURN_URL = 'returnUrl';
